import React from 'react'

export const PostDetailPage = () => {
  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-border p-6">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-text-primary mb-4">Post Details</h1>
          <p className="text-text-secondary">Post detail functionality coming soon...</p>
        </div>
      </div>
    </div>
  )
} 